import { ChangeDetectorRef, Directive, Input, OnInit, Optional } from '@angular/core';
import { TooltipService } from '../services/tooltip.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective implements OnInit {
  @Input('appTooltip') tooltipKey: string = '';
  private subscription: Subscription | null = null;

  constructor(
    private tooltipService: TooltipService,
    @Optional() private ngbTooltip: NgbTooltip,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {

    if (!this.ngbTooltip) {
      console.warn('NgbTooltip not found on element. Ensure NgbTooltipModule is imported and ngbTooltip is applied.');
      return;
    }

    // Check if tooltips are already loaded
    if (this.tooltipService.isTooltipsLoaded()) {
      this.applyTooltipContent();
    } else {
      // Wait for tooltips to load
      this.subscription = this.tooltipService.getTooltipsObservable().subscribe({
        next: () => {
          this.applyTooltipContent();
        },
        error: (error) => {
          console.error('Error loading tooltips:', error);
          this.applyTooltipContent(); // Apply fallback content
        }
      });
    }
  }

   private applyTooltipContent() {
    const tooltipContent = this.tooltipService.getTooltipContent(this.tooltipKey);
    this.ngbTooltip.ngbTooltip = tooltipContent;
    this.cdr.markForCheck();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
